import { AppSettings } from '../constants';
import Jwt from '../helper/interceptors';
import { MapResponse } from '../helper/helper-api';

const portal = AppSettings.clientTypeValue
  ? AppSettings.clientTypeValue.toLowerCase()
  : '';
const prefixUrl = `/api/${portal}/accounts`;

export const requestLogin = params => {
  return Jwt(AppSettings.CURRENT_SITE_URI)
    .post('/oauth/token', params)
    .then(response => {
      return MapResponse(response);
    })
    .catch(error => {
      var response = error.response;
      return MapResponse(response);
    });
};

export const getIzendaToken = () => {
  console.log('getIzendaToken');
  return Jwt(AppSettings.REPORT_URL, true)
    .post('/api/tokens')
    .then(response => {
      return MapResponse(response);
    })
    .catch(error => {
      var response = error.response;
      return MapResponse(response);
    });
};

export const getCurrentUser = token => {
  if (token) {
    const headers = [{ key: 'Authorization', value: `bearer ${token}` }];
    return Jwt(AppSettings.CURRENT_SITE_URI, true, { headers })
      .get('/oauth/current-user')
      .then(response => {
        return MapResponse(response);
      })
      .catch(error => {
        var response = error.response;
        return MapResponse(response);
      });
  } else {
    return Jwt(AppSettings.CURRENT_SITE_URI)
      .get('/oauth/current-user')
      .then(response => {
        return MapResponse(response);
      })
      .catch(error => {
        var response = error.response;
        return MapResponse(response);
      });
  }
};

export const sendRequestForgotPassword = params => {
  return Jwt(AppSettings.SITE_ONE_SERVICE_URI)
    .post(`${prefixUrl}/send-email-reset-password`, params)
    .then(response => {
      return MapResponse(response);
    })
    .catch(error => {
      var response = error.response;
      return MapResponse(response);
    });
};

export const getUserByClientIdAndEmail = params => {
  return Jwt(AppSettings.SITE_ONE_SERVICE_URI)
    .get(`${prefixUrl}/by-email/${params.clientId}/${params.email}`)
    .then(response => {
      return MapResponse(response);
    })
    .catch(error => {
      var response = error.response;
      return MapResponse(response);
    });
};

export const sso = params => {
  return (
    Jwt(AppSettings.CURRENT_SITE_URI)
      .post('oauth/sso', params)
      // return Jwt('http://test.localhost:8053').post('oauth/sso', params)
      .then(response => {
        return MapResponse(response);
      })
      .catch(error => {
        var response = error.response;
        return MapResponse(response);
      })
  );
};

export const verifyTokenActiveUser = params => {
  return Jwt(AppSettings.SITE_ONE_SERVICE_URI)
    .post(`/api/${portal}/accounts/verify-token-active-user`, params)
    .then(response => {
      return MapResponse(response);
    })
    .catch(error => {
      var response = error.response;
      return MapResponse(response);
    });
};

export const verifyTokenConfirmEmail = params => {
  return Jwt(AppSettings.SITE_ONE_SERVICE_URI)
    .post(`/api/${portal}/accounts/verify-token-confirm-email`, params)
    .then(response => {
      return MapResponse(response);
    })
    .catch(error => {
      var response = error.response;
      return MapResponse(response);
    });
};

export const verifyTokenResetPassword = params => {
  return Jwt(AppSettings.SITE_ONE_SERVICE_URI)
    .post(`/api/${portal}/accounts/verify-token-reset-password`, params)
    .then(response => {
      return MapResponse(response);
    })
    .catch(error => {
      var response = error.response;
      return MapResponse(response);
    });
};

export const logout = params => {
  return Jwt(AppSettings.CURRENT_SITE_URI)
    .get('/oauth/logout', params)
    .then(response => {
      return MapResponse(response);
    })
    .catch(error => {
      var response = error.response;
      return MapResponse(response);
    });
};

export const getHOBranding = params => {
    const headers = [{ key: 'Authorization', value: `bearer ${params.token}`}];
    return Jwt(AppSettings.GLOBAL_API_URL, true, { headers })
      .get(`/apiv1/homeowners/HomeOwnerbrandsetting?Email=${params.email}&IsGetAllHOBrandUrl=0`)
      .then(response => {
        return MapResponse(response);
      })
      .catch(error => {
        var response = error.response;
        return MapResponse(response);
      });

};

// export const externalUserAuth = params => {
//   return Jwt(AppSettings.SITE_ONE_SERVICE_URI)
//   .put(`/oauth/SSOLogin?token=${params.token}`)
//   .then(response => {
//       return MapResponse(response);
//     })
//     .catch(error => {
//       var response = error.response;
//       return MapResponse(response);
//     });
// };
	
export const externalUserAuth = params => {
  return Jwt(AppSettings.SITE_ONE_SERVICE_URI)
  .put(`/oauth/SSOLogin?token=${params.token}`)
  .then(response => {
      return MapResponse(response);
    })
    .catch(error => {
      var response = error.response;
      return MapResponse(response);
    });
};



// WEBPACK FOOTER //
// ./src/Auth/api.js